// extracted by mini-css-extract-plugin
export default {"trash":"delete-img-icon_trash__VPsR9"};